//
//
//
//
//
//
//

export default {
  name: 'null-data',
  props: ['image', 'text']
};



// WEBPACK FOOTER //
// ./src/components/NullData.vue